module.exports = function anonymous(it
) {
var out='<li class="log-entry log-more-records"> <div class="centered pointer"> ';if(it.more){out+=' <a class="link">'+(it.more)+'</a> ';}else{out+=' <a class="link" rel="localize[log.more]">more...</a> ';}out+=' </div></li>';return out;
}